import store from '@/store';

export default (to: any, from: any, next: any) => {
  if (!to.meta.isPublic) {
    store.dispatch('oidc/oidcCheckAccess', to)
    .then((hasAccess: boolean) => {
      if (hasAccess) {
        next();
      }
    });
  } else {
    next();
  }
};
